import appAxios from '@/axios/appAxios';
export default{
    namespaced:true,
    state:{
        user:null,
        list:null
    },
    getters:{
        getUser(state){
            return state.user;
        },
        getUserId(state){
            return state.user?.userID
        },
        getToken(state){
            return state.user?.accessToken;
        },
        getList(state){
            return state.list;
        }
        
    },
    mutations:{
        setUser(state,user){
            state.user=user;
        },
        setList(state,list){
            state.list=list;
        },
        deleteItem(state,item){
            state.list=state.list.filter(x=>x.id!==item.id);
        }
    },
    actions:{
       async LoginAsync(context,user){
           return await appAxios.post('/user/login',user)
        },
        async RegisterAsync(context,user){
            return await appAxios.post('/user/register',user)
        },async AuthControlAsync(){
           return await appAxios.get('/user/auth')
        },
        async UserListFetch(context){
         -
            await appAxios.get('/User').then(({data})=>{
                context.commit('setList',data);
               }).catch(err=>{
                console.log(err);
               })
        },
       async deleteItem(context,item){
           return await appAxios.delete('/User/'+item.id);
        },
        async changePassword(context,{item,newPassword}){
            var json={
                id:item.id,
                newPassword
            }
            return await appAxios.put('/User/'+item.id,json);
        }
    }
}